
// Override Settings
var bcSfFilterSettings = {
  general: {
      limit: 10,
  }
};

// Declare Templates
var bcSfFilterTemplate = {
  'soldOutClass': 'sold-out',
  'saleClass': 'sale',
  'soldOutLabelHtml': '<div>' + bcSfFilterConfig.label.sold_out + '</div>',
  'saleLabelHtml': '<div>' + bcSfFilterConfig.label.sale + '</div>',
  'vendorHtml': '<div>{{itemVendorLabel}}</div>',

  // Grid Template
  'productGridItemHtml': '<div class="product-grid" data-product-id="{{id}}" data-tags="{{itemTags}}">' +
                        '<div class="img-container">' +
                                '<a href="{{itemUrl}}" onclick="track_click(event);" data-product-id="{{id}}" class="js-img-hover gap-cl-cta" onmouseenter="window.hoverSecond($(this))" onmouseleave="window.hoverSecond($(this))">' +
                     '<div class="hover-img-container aspect-ratio-container">' +
          '<img class="lazyload lazyload--placeholder aspect-ratio-image" data-src="{{itemThumbUrl}}" alt="">' +
          '<img class="hover-show aspect-ratio-image" src="{{itemThumbUrl2}}" alt="" style="display:none;">' +
      '</div>' +
                                '</a>' +
                                '<button class="js-quick-add quick-add-btn {{btnAvailabilityClass}}" data-color="{{currentColor}}" data-handle="{{prHandle}}" onclick="toggleQuickadd($(this))" data-pr-title="{{prTitle}}">' +
                                '{{quickAddBtn}}' +
                              '</button>' +
                '{{sustainabilityIcon}}'+
                            '</div>' +
                            '<div class="prod-details {{saleClass}}">' +
                                '<div class="prod-title"><a href="{{itemUrl}}">{{itemTitle}}</a></div>' +
                                  '{{itemPrice}}' +
                    '{{colorsNotice}}'+
                  '{{saleNotice}}' +
                  '{{promoNotice}}' +
                  '{{exclvNotice}}' +
                                  '{{annivAdultNotice}}' +            
                                  '{{annivKidsNotice}}' +
                  '{{justinNotice}}' +
                  '{{customLabel}}' +
                  //'{{springFlow}}' +
                            '</div>' +
                        '</div>',

  // Pagination Template
  'previousActiveHtml': '<li><a href="{{itemUrl}}">&larr;</a></li>',
  'previousDisabledHtml': '<li class="disabled"><span>&larr;</span></li>',
  'nextActiveHtml': '<li><a href="{{itemUrl}}">&rarr;</a></li>',
  'nextDisabledHtml': '<li class="disabled"><span>&rarr;</span></li>',
  'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
  'pageItemSelectedHtml': '<li><span class="active">{{itemTitle}}</span></li>',
  'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
  'paginateHtml': '<ul class="pagination-custom">{{previous}}{{pageItems}}{{next}}</ul>',

  // Sorting Template
//     'sortingHtml': '<label class="label--hidden">' + bcSfFilterConfig.label.sorting + '</label><select class="collection-sort__input">{{sortingItems}}</select>',
  'sortingHtml': '<select class="collection-sort__input">{{sortingItems}}</select>',
};

/************************** BUILD PRODUCT LIST **************************/

window.filcnt = 0;

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
  /*** Prepare data ***/
  var images = data.images_info;
  var availableVariants = data.variants.filter(variant => variant.available)
  var firstAvailableVariant = availableVariants[0]
  var soldOut = !data.available; // Check a product is out of stock
  //var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  var priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
      var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
      for (var i = 0; i < data['variants'].length; i++) {
          if (data['variants'][i].available) {
              firstVariant = data['variants'][i];
              break;
          }
      }
  }
  /*** End Prepare data ***/

  // console.log(data)



  //Wag irender ang mga sale items kapag hindi sale collection
//     if(!collection_is_for_sale) {
//       if(data.tags.includes("Sale") || data.compare_at_price > data.price) {
//         return '';
//       }
//     }

  // Get Template
  var itemHtml = bcSfFilterTemplate.productGridItemHtml;

  itemHtml = itemHtml.replace(/{{itemTags}}/g, data.tags.join(','));

  // Add Thumbnail
  var itemThumbUrl = images.length > 0 ? formatImageSize(images[0]['src'], '360x') : bcSfFilterConfig.general.no_image_url;
  itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

  // 2nd Thumbnail
  var itemThumbUrl2 = images.length > 1 ? formatImageSize(images[1]['src'], '360x') : this.optimizeImage(images[0]['src']);
  itemHtml = itemHtml.replace(/{{itemThumbUrl2}}/g, itemThumbUrl2);

  var variantsOnSale = ''

  if(data.tags.includes('Sale')) {
    variantsOnSale = data.variants.filter(variant => variant.available && variant.compare_at_price > variant.price )
  }

  
  // Add Price
  var itemPriceHtml = '';
  if (data.title != '')  {
    
    
     itemPriceHtml += '';
      if (onSale && variantsOnSale.length > 0) {
//           if (priceVaries) {
        
        itemPriceHtml += '<span class="regular-price strike">' + this.formatMoney(data.compare_at_price_min) + '</span> ' + '<span class="sale-price"> Now ' + this.formatMoney(variantsOnSale[0].price) + '<span>';
//             itemPriceHtml +=  '<span class="regular-price">' + this.formatMoney(variantsOnSale[0].price) + '</span>';
//             itemPriceHtml += '<span class="sale-price">' + (bcSfFilterConfig.label.from_price).replace(/{{ price }}/g, this.formatMoney(variantsOnSale[0].compare_at_price)) + '</span>';
//           } 
//           else {
//             itemPriceHtml += '<span class="regular-price">' + this.formatMoney(data.compare_at_price_min) + '</span> ' + '<span class="sale-price"> Now ' + this.formatMoney(variantsOnSale[0].price) + '<span>';
// //             itemPriceHtml +=  '<span class="regular-price">' + this.formatMoney(data.price_min) + '<span>';
//           }
      } else {
//           if (priceVaries) {
//             itemPriceHtml += '<span class="regular-price">' + (bcSfFilterConfig.label.from_price).replace(/{{ price }}/g, this.formatMoney(firstAvailableVariant.price)) + '</span>';
//           } else {
          itemPriceHtml +=  '<span class="regular-price">' + this.formatMoney(firstAvailableVariant.price) + '</span>';
//           }
      }
      itemPriceHtml += '';
  }
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

  // Add soldOut class
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

  // Add onSale class
  var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

  // Add soldOut Label
  var itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
  itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

  // Add onSale Label
  var itemSaleLabelHtml = onSale ? bcSfFilterTemplate.saleLabelHtml : '';
  itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);

  // Add Vendor
  var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

  //Add additonal color notice
  var colorNotice = '';
  var saleNotice = '';
  var promoNotice = '';
  var exclsvNotice = '';
  var annivAdultNotice = '';
  var annivKidsNotice = '';
  var justinNotice = '';
  var customLabel = '';
//     var springFlow = '';
  
  var productVariants = data.options_with_values;
  var productcolors = '';
  var colorCtr = 0;
  let dataTags = data.tags;
  let textLabel = '',
      lowinStock = false;

  $.each(productVariants, function(i,e) {
    if (e.name == "color") {
      $.each(e.values, function(id,el) {
        colorCtr++;
      });
    }
  });  

  for(var t = 0; dataTags.length > t; t++ ){
    if(dataTags[t].substring(0, 5) == 'Label'){
      textLabel = dataTags[t].substring(8, dataTags[t].length)
      lowinStock = (textLabel == 'Low in stock') ? true : false;

      customLabel += `<span class="prod-notice">${textLabel}</span>`;
    }
  }

  if(data.tags.indexOf('Sale') > -1 && variantsOnSale.length > 0){
    saleNotice = '<span class="prod-notice">Sale</span>';
  } else{
     saleNotice = ''; 
  }
  if(data.tags.indexOf('Promo') > -1){
    promoNotice = '<span class="prod-notice">Limited Time Only</span>';
  } else {
    promoNotice = ''; 
  }
  if(data.tags.indexOf('Online Exclusives') > -1){
  exclsvNotice = '<span class="prod-notice">online exclusive</span>'
  } else{
      exclsvNotice = ''
  }

  if(data.tags.indexOf('50th Adult') > -1){
      annivAdultNotice = '<span class="prod-notice">Denim Through the Decades</span>'
  } else {
      annivAdultNotice = ''; 
  }

  if(data.tags.indexOf('50th KB') > -1){
      annivKidsNotice = '<span class="prod-notice">The 1969 Premium Collection</span>'
  } else {
      annivKidsNotice = ''; 
  }

  if(data.tags.indexOf('Gap Spring 20') > -1 && !(data.tags.indexOf('Sale') > -1) && !lowinStock){
      justinNotice = '<span class="prod-notice">Just in!</span>'
  } else {
      justinNotice = ''; 
  }

 
//     if(data.tags.indexOf('Gap Spring 20') > -1 && data.tags.indexOf('Flow 2') > -1 && data.tags.indexOf('Regular') > -1){
//         springFlow = '<span class="prod-notice">Available online, in-store 3/16</span>'
//     } else {
//         springFlow = ''; 
//     }

  if(colorCtr > 1){
  colorNotice = '<span class="prod-notice">see additional colors</span>';
  } else{
     colorNotice = ''; 
  }

  // var panelHtml = window.panelHtml.html

  var quickAddBtn = theme.quickAddIcon;

  var sizesOptions = '',
      waistOptions = '',
      lengthOptions = '',
      variantsOptions = '',
      singleOptions = '';

  var outofStockLine = `<svg class="swatch__out-of-stock-indicator" version="1.1" xmlns="http://www.w3.org/2000/svg">
                               <line stroke="#000000" stroke-width="1" x1="0" x2="100%" y1="40" y2="0"></line>
                            </svg>`

  var prVariants = data.variants;
  var allAvailableVariants = data.variants.filter(variant => variant.available)
  
  var firstAvailableVariants = allAvailableVariants[0]
  
  var selectedColorVariants = data.variants.filter(variant => variant.option_color === firstAvailableVariants.option_color && variant.available)
  
  var options_without_color = data.options_with_values.filter(option => option.name !== 'color').filter(option => option.name !== 'inseam')
  

  selectedColorVariants.map(variant => {
    var options = variant.options.splice(variant.option_color, 1)
    
    variantsOptions += `<option value="${variant.id}" data-available="${variant.available}">[${JSON.stringify(variant.options)}]</option>`;
  })
  
  
  var sizesArr = [],
      lengthArr = [],
      waistArr = [],
      uniqueSizes = [];


  data.variants.map(variant => {
    if(variant.available) {
      if(!sizesArr.includes(variant.option_size)) {
        uniqueSizes.push(variant)
        sizesArr.push(variant.option_size)
      }
    }
  })
  var btnAvailabilityClass = data.available ? 'ready-to-add' : 'out-of-stock';
  
  options_without_color.map((option, i) => {
      if(options_without_color.length <= 1) {
        selectedColorVariants.map(variant => {
//               console.log(option, ' ', data.title, ' ', data.id)
            singleOptions += `<li class="item ${!variant.available ? 'out-of-stock' : ''}" data-id="${variant.id}" ${variant.available ? 'onclick="selectSingleVariant($(this))"' : ''}><div class="label">${variant.option_size || variant.option_waist}${!variant.available ? outofStockLine : ''}</div></li>`
        })
      }else if(option.name == 'size') {
        option.values.map(variant => {
          sizesOptions += `<li class="item" onclick="selectVariant($(this))" data-index="${i}" data-option="${option.name}"><div class="label">${variant.title }</div></li>`
        })
      }else if(option.name == 'waist') {
        option.values.map(variant => {
          waistOptions += `<li class="item" onclick="selectVariant($(this))" data-index="${i}" data-option="${option.name}"><div class="label">${variant.title }</div></li>`
        })
      }else if(option.name == 'length') {
        option.values.map(variant => {
          lengthOptions += `<li class="item" onclick="selectVariant($(this))" data-index="${i}" data-option="${option.name}"><div class="label">${variant.title }</div></li>`
        })
      }
  });



var variantContainerHtml = `<select class="prod-variants-with__id" style="display:none;">${variantsOptions}</select>`

  var lengthContainerHtml = lengthOptions.length > 0 || lengthOptions !== '' ?`
    <div class="length options main-option">
  ${lengthOptions.length > 0 || '' ? '<h3>Length:</h3>' : ''}
      <ul class="length options">
    ${lengthOptions}
      </ul>
</div>` : ''
  
  var waistContainerHtml = waistOptions.length > 0 || lengthOptions !== '' ? `
    <ul class="waist options main-option">
  ${waistOptions}
  </ul>` : ''
  
  var sizeContainerHtml = sizesOptions.length > 0 || sizesOptions !== '' ? `
    <ul class="sizes options main-option">
  ${sizesOptions}
  </ul>` : ''
  
  var singleOptionContainerHtml = singleOptions.length > 0 || singleOptions !== '' ? `
  <ul class="single options main-option">
  ${singleOptions}
  </ul>` : ''


  var color_index = data.options_with_values.findIndex(option => option.name === 'color')
  var first_color = firstAvailableVariant.title.split(' / ')[color_index];

  itemHtml = itemHtml.replace(/{{hideCard}}/g, !data.available ? 'hide-oos' : '')
  itemHtml = itemHtml.replace(/{{currentColor}}/g, first_color)
  itemHtml = itemHtml.replace(/{{prTitle}}/g, data.title.replace(/"/g, "'"))
  itemHtml = itemHtml.replace(/{{prHandle}}/g, data.handle);

  itemHtml = itemHtml.replace(/{{btnAvailabilityClass}}/g, data.available ? 'ready-to-add' : 'out-of-stock')

  itemHtml = itemHtml.replace(/{{quickAddBtn}}/g, quickAddBtn);
  // panelHtml = panelHtml.replace(/{{singleOptions}}/g, singleOptionContainerHtml);
  // panelHtml = panelHtml.replace(/{{btnAvailabilityClass}}/g, btnAvailabilityClass);
  // panelHtml = panelHtml.replace(/{{quickAddBtn}}/g, quickAddBtn);
  // panelHtml = panelHtml.replace(/{{sizes}}/g, sizesOptions);
  // panelHtml = panelHtml.replace(/{{waist}}/g, waistContainerHtml);
  // panelHtml = panelHtml.replace(/{{length}}/g, lengthContainerHtml);
  // panelHtml = panelHtml.replace(/{{variantContainerHtml}}/g, variantContainerHtml);
  
  // itemHtml = itemHtml.replace(/{{selectionHtml}}/g, panelHtml);

  itemHtml = itemHtml.replace(/{{colorsNotice}}/g, colorNotice);
  itemHtml = itemHtml.replace(/{{saleNotice}}/g, saleNotice);
  itemHtml = itemHtml.replace(/{{exclvNotice}}/g, exclsvNotice);
  itemHtml = itemHtml.replace(/{{annivAdultNotice}}/g, annivAdultNotice);
  itemHtml = itemHtml.replace(/{{annivKidsNotice}}/g, annivKidsNotice);
  itemHtml = itemHtml.replace(/{{justinNotice}}/g, justinNotice);
  itemHtml = itemHtml.replace(/{{customLabel}}/g, customLabel);
//   	itemHtml = itemHtml.replace(/{{springFlow}}/g, springFlow);

  itemHtml = itemHtml.replace(/{{promoNotice}}/g, promoNotice);
  // Add main attribute (Always put at the end of this function)
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
  itemHtml = itemHtml.replace(/{{id}}/g, data.id);

  var sustinability_icon_tpl = data.tags.includes('Gap For Good') ? `<div class="sustainability_product"><img class="sustainbility_icon" loading="lazy" width="37" height="33" src="${bcSfFilterConfig.sustainability_icon}" alt="Gap For Good"></div>` : '';

  itemHtml = itemHtml.replace(/{{sustainabilityIcon}}/g, sustinability_icon_tpl);

  var saleHandles = ["men-1", "women-1", "girls-1", "boys-1", "boys-1", "toddler-girls-1", "toddler-boys-1"]
  
  var currentHandle = location.pathname.replace('/collections/', '').trim()

var oosSale = saleHandles.includes(currentHandle) && variantsOnSale.length <= 0


  if(data.price == 0 || data.price < 1){
    return '';
  } else {
    window.filcnt++;
    return itemHtml;
  }
};

// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data) {
  // // Add Description
  // var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
  // // Truncate by word
  // itemDescription = (itemDescription.split(" ")).length > 51 ? itemDescription.split(" ").splice(0, 51).join(" ") + '...' : itemDescription.split(" ").splice(0, 51).join(" ");
  // // Truncate by character
  // itemDescription = itemDescription.length > 350 ? itemDescription.substring(0, 350) + '...' : itemDescription.substring(0, 350);
  // itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
};

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
  if (this.getSettingValue('general.paginationType') == 'default') {
      // Get page info
      var currentPage = parseInt(this.queryParams.page);
      var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

      // If it has only one page, clear Pagination
      if (totalPage == 1) {
          jQ(this.selector.bottomPagination).html('');
          return false;
      }

      if (this.getSettingValue('general.paginationType') == 'default') {
          var paginationHtml = bcSfFilterTemplate.paginateHtml;

          // Build Previous
          var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
          previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
          paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

          // Build Next
          var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
          nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
          paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

          // Create page items array
          var beforeCurrentPageArr = [];
          for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
              beforeCurrentPageArr.unshift(iBefore);
          }
          if (currentPage - 4 > 0) {
              beforeCurrentPageArr.unshift('...');
          }
          if (currentPage - 4 >= 0) {
              beforeCurrentPageArr.unshift(1);
          }
          beforeCurrentPageArr.push(currentPage);

          var afterCurrentPageArr = [];
          for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
              afterCurrentPageArr.push(iAfter);
          }
          if (currentPage + 3 < totalPage) {
              afterCurrentPageArr.push('...');
          }
          if (currentPage + 3 <= totalPage) {
              afterCurrentPageArr.push(totalPage);
          }

          // Build page items
          var pageItemsHtml = '';
          var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
          for (var iPage = 0; iPage < pageArr.length; iPage++) {
              if (pageArr[iPage] == '...') {
                  pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
              } else {
                  pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
              }
              pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
              pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
          }
          paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

          jQ(this.selector.bottomPagination).html(paginationHtml);
      }
  }
};

function formatImageSize(src, size) {
// remove any current image size then add the new image size
return src
  .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
  .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function(match) {
    return '_'+size+match;
  })
;
}


/************************** BUILD TOOLBAR **************************/
let sort_count = 0;
// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function(e) {
  if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
      jQ(this.selector.topSorting).html('');
//         console.log(sort_count)
      var sortingArr = this.getSortingList();
      if (sortingArr) {
          const selectDefault = (sort_count == 0) ? "sort" : (this.queryParams.sort == "extra-sort1-ascending") ? "sort" : this.queryParams.sort
          
          // Build content 
          var sortingItemsHtml = '';
              sortingItemsHtml += '<option value="sort" selected disabled hidden>Sort By</option>';
          for (var k in sortingArr) {
              sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
          }
//           	console.log(sortingItemsHtml)
          var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
//           	console.log(html)
          jQ(this.selector.topSorting).html(html);

//           	console.log(this.queryParams)
          // Set current value
//           	console.log(sortingArr)
        // jQ(this.selector.topSorting + ' select').val('manual');
    sort_count++
      }
  }
};


BCSfFilter.prototype.buildSortingEvent = function() {
  var self = this;
  jQ(this.getSelector('topSorting') + ' select').change(function(e) {
//       console.log(self.queryParams.sort)
//       console.log(jQ(this).val())
    onInteractWithToolbar(e, 'sort', self.queryParams.sort, jQ(this).val());
  })
};




// Build Display type (List / Grid / Collage)
// BCSfFilter.prototype.buildFilterDisplayType = function() {
//     var itemHtml = '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="change-view bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
//     itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="change-view bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
//     jQ(this.selector.topDisplayType).html(itemHtml);

//     // Active current display type
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('active');
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('active');
//     if (this.queryParams.display == 'list') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('active');
//     } else if (this.queryParams.display == 'grid') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('active');
//     }
// };

/************************** END BUILD TOOLBAR **************************/

// Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData=function(data){for(var k=0;k<data.length;k++){data[k]['images']=data[k]['images_info'];if(data[k]['images'].length>0){data[k]['featured_image']=data[k]['images'][0]}else{data[k]['featured_image']={src:bcSfFilterConfig.general.no_image_url,width:'',height:'',aspect_ratio:0}}data[k]['url']='/products/'+data[k].handle;var optionsArr=[];for(var i=0;i<data[k]['options_with_values'].length;i++){optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options']=optionsArr;data[k]['price_min']*=100,data[k]['price_max']*=100,data[k]['compare_at_price_min']*=100,data[k]['compare_at_price_max']*=100;data[k]['price']=data[k]['price_min'];data[k]['compare_at_price']=data[k]['compare_at_price_min'];data[k]['price_varies']=data[k]['price_min']!=data[k]['price_max'];var firstVariant=data[k]['variants'][0];if(getParam('variant')!==null&&getParam('variant')!=''){var paramVariant=data.variants.filter(function(e){return e.id==getParam('variant')});if(typeof paramVariant[0]!=='undefined')firstVariant=paramVariant[0]}else{for(var i=0;i<data[k]['variants'].length;i++){if(data[k]['variants'][i].available){firstVariant=data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant']=firstVariant;for(var i=0;i<data[k]['variants'].length;i++){var variantOptionArr=[];var count=1;var variant=data[k]['variants'][i];var variantOptions=variant['merged_options'];if(Array.isArray(variantOptions)){for(var j=0;j<variantOptions.length;j++){var temp=variantOptions[j].split(':');data[k]['variants'][i]['option'+(parseInt(j)+1)]=temp[1];data[k]['variants'][i]['option_'+temp[0]]=temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options']=variantOptionArr}data[k]['variants'][i]['compare_at_price']=parseFloat(data[k]['variants'][i]['compare_at_price'])*100;data[k]['variants'][i]['price']=parseFloat(data[k]['variants'][i]['price'])*100}data[k]['description']=data[k]['content']=data[k]['body_html']}return data};

// Add additional feature for product list, used commonly in customizing product list
// BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
//   console.log(data, eventType)
// };


window.init = 1;
// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  // Get product count info
  var from = this.queryParams.page == 1 ? this.queryParams.page : (this.queryParams.page - 1) * this.queryParams.limit + 1;
  var to = from + data.products.length - 1;
  if (to > data.total_product) to = data.total_product;

  // Update product counts
  jQ('#sort-total-products').text($('div#bc-sf-filter-products .product-grid').length);
  jQ('#sort-total-products2').text($('div#bc-sf-filter-products .product-grid').length);
  jQ('#sort-total-products3').text($('div#bc-sf-filter-products .product-grid').length);

  // Add dividers after products are rendered
  const divMetaElement = jQ('#div_meta');

  if(divMetaElement.length > 0) {
    const meta_switch = divMetaElement.data('switch');
    const meta_headers = divMetaElement.data('headers');
    
    if(meta_switch && meta_headers) {
      // Clear any existing timeouts
      if (window.dividerTimeout) {
        clearTimeout(window.dividerTimeout);
      }

      const addDividers = () => {
        // Remove existing dividers first
        jQ('.division--line').remove();
        
        // Create sections object to store products by tag
        const sections = {};
        meta_headers.forEach(header => {
          sections[header.tag] = {
            name: header.name,
            products: []
          };
        });
        
        // Sort products into their respective sections
        const allProducts = jQ('#bc-sf-filter-products .product-grid');
        allProducts.each(function() {
          const product = jQ(this);
          const productTags = (product.attr('data-tags') || '').split(',').map(tag => tag.trim());
          
          // Find the first matching header tag for this product
          const matchingHeader = meta_headers.find(header => productTags.includes(header.tag));
          if (matchingHeader) {
            sections[matchingHeader.tag].products.push(product);
            // Remove the product from DOM temporarily
            product.detach();
          }
        });
        
        // Reinsert products in the correct order with dividers
        const productsContainer = jQ('#bc-sf-filter-products');
        meta_headers.forEach(header => {
          const section = sections[header.tag];
          if (section.products.length > 0) {
            // Add divider
            const divider = `<div class="relative-container division--line"><span>${section.name}</span></div>`;
            productsContainer.append(divider);
            
            // Add all products from this section
            section.products.forEach(product => {
              productsContainer.append(product);
            });
          }
        });
      };

      // Initial load with longer timeout to ensure products are loaded
      window.dividerTimeout = setTimeout(addDividers, 1000);

      // Handle infinite scroll and filtering
      jQ(window).off('scroll.dividers').on('scroll.dividers', function() {
        if (window.dividerTimeout) {
          clearTimeout(window.dividerTimeout);
        }
        window.dividerTimeout = setTimeout(addDividers, 500);
      });
    }
  }

  // Track product impressions
  if(typeof(track_product_impression) === 'function' && (eventType === 'init' || eventType === 'sort')) {
    var products = data.products.filter(product => product.available);
    if(products.length > 0) {
      track_product_impression(products)
    }
  }

  // Update UI elements
  jQ('#sort-total-products2').closest('.item-count-container').css('opacity', '');

  jQ('#bc-sf-filter-options-wrapper').append('<div id="close-for-filter"><span class="one-line"></span><span class="two-line"></span></div>')

  // Handle filter mode class
  if(jQ('.bc-sf-filter-pc.bc-sf-filter-selection-wrapper').length){
    $('.collections-main .filter-section').addClass('filtering-mode');
  } else{
    $('.collections-main .filter-section').removeClass('filtering-mode');
  }

  // Handle click events for color options
  $(document).on('click', '.main-option.colors li', function() {
    var $this = $(this),
        color = $this.find('input').val(),
        btn = $this.closest('.quick-add-options').siblings('.quick-add-container').find('button');
    
    $this.addClass('selected').siblings().removeClass('selected')
    replaceVariantSelection(theme.currentSelectedProducts, btn, color)
  });

  // Handle click events for product options
  $(document).on('click', '.product-grid .quick-add-options .options .item:not(.out-of-stock)', function() {
    var $this = $(this),
        currentProduct = theme.currentSelectedProduct,
        optionsWithoutColor = currentProduct.options_with_values.filter(option => option.name !== 'Color'),
        btn = $this.closest('.size-options').siblings('.js-quick-add'),
        selectedValues = [];
    
    $this.addClass('selected').siblings().removeClass('selected')
    
    var selected = $('.quick-add-options .options:not(.colors) .item.selected')
    
    $('.options:not(.colors) item.selected [data-option-label]').each((index, item) => {
      var $this = $(item),
          value = $this.find('.label').text().trim();
      selectedValues.push(value);
    });
    
    var selectedVariant = getVariantId(selectedValues)
    
    updateAddToBagBtn(selected.length, optionsWithoutColor.length, btn, selectedVariant)
    
    $(this).closest('.size-options').find('.quick-add-warning').hide();
  });

  // Handle mouseup event for quick-add-options
  $(document).mouseup(function(e) {
    if (!$(".quick-add-options").is(e.target) && $(".quick-add-options").has(e.target).length === 0) 
    {
      var container = $(".quick-add-options");
      container.parent().find('.js-quick-add').show();
      container.parent().find('.quick-add-bg').remove();
      container.remove()
    }
  });
};

// Remove the scroll event listener when leaving the page
jQ(document).ready(function() {
jQ(window).on('unload', function() {
  jQ(window).off('scroll.dividers');
});
});

// Remove the scroll event listener when leaving the page
jQ(document).ready(function() {
jQ(window).on('unload', function() {
  jQ(window).off('scroll.dividers');
});
});

// Remove the scroll event listener when leaving the page
jQ(document).ready(function() {
jQ(window).on('unload', function() {
  jQ(window).off('scroll.dividers');
});
});

// Remove the scroll event listener when leaving the page
jQ(document).ready(function() {
jQ(window).on('unload', function() {
  jQ(window).off('scroll.dividers');
});
});


//! MADE BY RENGIE FOR THE MEN/WOMEN DIVISION
if(jQ('#div_meta').data('switch')){
const meta_headers = jQ('#div_meta').data('headers')

// let division_obj = meta_headers.reduce((obj, {name, tag}, i) => {
//   const divObj = {}

//   divObj.tags = tag
//   divObj.divisionArray = [`<div class="relative-container division--line"><span>${name}</span></div>`]

//   obj.push(divObj)

//   return obj
// }, [])


// BCSfFilter.prototype.buildProductListData = function(a, b) {
//   if(b != 'page'){
//     division_obj = meta_headers.reduce((obj, {name, tag}, i) => {
//       const divObj = {}
//       divObj.tags = tag
//       divObj.divisionArray = [`<div class="relative-container division--line"><span>${name}</span></div>`]
//       obj.push(divObj)
//       return obj
//     }, [])
//   }

//   let c = "",
//       FilteredDivision = a.reduce((arr,item) => {
//         division_obj.forEach((div) => {
//           if(item.tags.includes(div.tags)){
//             div.divisionArray = div.divisionArray.concat(item)
//             arr = arr.concat(div.divisionArray)
//           }
//         })
//         return arr
//       }, []),
//       mergedData = division_obj.reduce((arr, {divisionArray}) => {
//         if(divisionArray.length > 1){
//           arr = arr.concat(divisionArray)
//         }
//         return arr
//       }, [])
//   for (let e = 0; e < mergedData.length; e++) {
//     if(typeof mergedData[e] !== 'object'){
//       c += mergedData[e]
//     } else{
//       let f = this.buildProductGridItem(mergedData[e], e + 1, mergedData.length)
//       c += this.buildProductItemAdvanced(mergedData[e], f)
//     }
//   }

//   jQ(this.getSelector("products")).empty();
//   jQ(this.getSelector("products")).append(c);
// }

}


// BCSfFilter.prototype.buildFilterOptionBox = function(data, filterTreeId) {
//     // Sort values
//     if (data.hasOwnProperty('values') && (data.valueType == 'all' || this.getSettingValue('general.sortManualValues') || (data.valueType != 'all' && data.sortManualValues))) data.values = this.sortFilterOptionValue(data);
//     // Build content
//     var itemsContent = '';
//     var fOType = data.filterType,
//         fODisplayType = data.displayType,
//         fOSelectType = data.selectType,
//         fOId = data.filterOptionId,
//         fOLabel = data.label;

//   	/* BC Group Sizes - 17530 */
//   	// Group values
//     var newCustomSizes = {};
//   	var currentSizes = data.values;
// 	var customSizes = bcSfFilterConfig.custom_sizes;
//   	for (var k = 0; k < customSizes.length; k++) {
//       	// Build group size
//       	var groupName = customSizes[k]['group'];
//       	newCustomSizes[groupName] = [];	
    
//       	var sizes = customSizes[k]['items'].split('||');
//       	for (var i = 0; i < sizes.length; i++) {
//          	var existedSize = currentSizes.filter(function(e) { return e.key == sizes[i]; });
// 			if (typeof existedSize[0] !== 'undefined') 
//           		newCustomSizes[groupName].push(existedSize[0]);
//       	}
//   	}
//   	for (var j in newCustomSizes) {
// 		var groupSizes = newCustomSizes[j];
//       	itemsContent += '<p>' + j + '</p>';
//       	for (var t = 0; t < groupSizes.length; t++) {
//           	itemsContent += this.buildFilterOptionBoxData(fOType, fOId, fOLabel, fODisplayType, fOSelectType, groupSizes[t], data);
//       	}
//       	itemsContent += '';
//   	}
//     /* BC Group Sizes - 17530 */

//     //for (var k in data.values) {
//     //    itemsContent += this.buildFilterOptionBoxData(fOType, fOId, fOLabel, fODisplayType, fOSelectType, data['values'][k], data);
//     //}
//     // Get Template & Append to Filter Tree
//     if (itemsContent != '') {
//         var html = this.getTemplate('filterOptionBox');
//         html = html.replace(/{{itemList}}/g, itemsContent);
//         this.buildFilterOption(html, data, filterTreeId);
//     }
// };


//       //activate apply on click
//       $('.bc-sf-filter-option-item.bc-sf-filter-option-label').click(function(e){
//         	e.prevenDefault();
      
//           var $this = $(this),
//               $ulParent = $this.closest('ul'),
//               $buttonApply = $ulParent.siblings('.bc-sf-filter-select-button')

//               $.buttonApply.trigger('click')
//       })  


BCSfFilter.prototype.prepareFilterParams = function(params, eventType) {
  // Get collection id
  if (!this.queryParams.hasOwnProperty('collection_scope')) {
      if (!this.isSearchPage()) {
          params.collection_scope = parseInt(this.collectionId);
          if (eventType == 'history') {
              var historyData = History.getState().data;
              if (historyData.hasOwnProperty('param') && historyData.param.hasOwnProperty('collection_scope')) {
                  params.collection_scope = this.collectionId = parseInt(historyData.param.collection_scope);
              } else {
                  params.collection_scope = this.collectionId = parseInt(bcSfFilterConfig.general.collection_id);
              }
          }
      } else {
          params.collection_scope = 0;
      }
  } else {
      params.collection_scope = Array.isArray(this.queryParams.collection_scope) ? this.queryParams['collection_scope'][0] : this.queryParams['collection_scope'];
  }
  // Get product/variant available or not
  if (this.getSettingValue('general.availableAfterFiltering') == true) {
      params.product_available = this.checkExistFilterOptionParam() === true ? true : this.productAvailable;
      params.variant_available = this.checkExistFilterOptionParam() === true ? true : this.variantAvailable;
  } else {
      params.product_available = this.productAvailable;
      params.variant_available = this.variantAvailable;
  }
  // Get Tag value
  if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) params.tag = this.collectionTags;
  // Display filter option items even they return no product
  if (this.getSettingValue('general.showOutOfStockOption')) params.zero_options = true;
  // Build Filter tree or not
  params.build_filter_tree = (typeof eventType !== 'undefined' && this.imutableFilterTree.indexOf(eventType) > -1) ? false : true; // Except events of elements in filter tree, all remaining events do not rebuild filter tree
  // Enable cache when request params doest not have filter option values, "page" param equal to 1 and "sort" param equal to default sorting
  params.check_cache = (this.checkExistFilterOptionParam() === false && params['page'] == 1 && params['sort'] == this.defaultSorting && params['limit'] == this.getSettingValue('general.limit') && !this.isSearchPage() && !this.isVendorPage()) ? true : false;
  // Turn on price mode
  if (this.getSettingValue('general.priceMode') != '') params['price_mode'] = this.getSettingValue('general.priceMode');
  // Tag mode
  if (this.getSettingValue('general.tagMode') != '') params['tag_mode'] = this.getSettingValue('general.tagMode');
  // Availability Sorting
  if (this.getSettingValue('general.sortingAvailableFirst')) params.sort_first = 'available';
  // Vendor page: Get Vendor param
  if (this.isVendorPage() && params.hasOwnProperty('q')) {
      var vendorParam = this.getSettingValue('general.vendorParam');
      // params[vendorParam] = [params['q'].replace(/\+/g, ' ')];
      params[vendorParam] = [params['q']];
      delete params['q'];
  }

//   	params.sort = 'created-descending';
  params.sort = 'manual';
  
  return params;
};


/* Start Fix version 2.3.2 */
BCSfFilter.prototype.addFilterTreeItem=function(e,r,t,i){e=jQ.parseHTML(e);if(i!=this.selector.filterTree&&i!=this.selector.filterTreeHorizontal&&jQ(i).html(""),void 0===i)i="vertical"==t?this.selector.filterTree:this.selector.filterTreeHorizontal;void 0!==r&&"before"==r?jQ(i).prepend(e):jQ(i).append(e)};
/* End Fix version 2.3.2 */

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
  var self = bcsffilter;
  var ext = typeof ext !== 'undefined' ? ext : 'png';
  var version = typeof version !== 'undefined' ? version : '1';
  var prIndex = self.fileUrl.lastIndexOf('?');
  if (prIndex > 0) {
      var filePath = self.fileUrl.substring(0, prIndex);
  } else {
      var filePath = self.fileUrl;
  }
  filePath += fileName + '.' + ext + '?v=' + version;
  return filePath;
}

/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */
/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */


function addMarketingTiles() {
  const marketingContent = {
    'denim-shop-1': {
      insertAfter: 4,
      targetTag: '',
      html: `<div class="marketing-tile product-grid" data-marketing-tile="true">
               <a href="/collections/denim-shop" class="marketing-link gap-cl-cta">
                 <div class="img-container">
                   <div class="hover-img-container aspect-ratio-container">
                     <img 
                       class="lazyload aspect-ratio-image" 
                       data-src="https://cdn.shopify.com/s/files/1/0063/4932/4335/files/Banner_1_-_Denim_Page_Update_Desktop.jpg?v=1739163409" 
                       alt="Denim Story"
                     >
                   </div>
                 </div>
               </a>
             </div>`,
      inserted: false
    },
    'denim-shop-2': {
      insertAfter: 10,
      targetTag: '',
      html: `<div class="marketing-tile product-grid" data-marketing-tile="true">
               <a href="/collections/denim-shop" class="marketing-link gap-cl-cta">
                 <div class="img-container">
                   <div class="hover-img-container aspect-ratio-container">
                     <img 
                       class="lazyload aspect-ratio-image" 
                       data-src="https://cdn.shopify.com/s/files/1/0063/4932/4335/files/Banner_2_-_Denim_Page_Update_Desktop_Animated.gif?v=1739163409" 
                       alt="Logo Story"
                     >
                   </div>
                 </div>
               </a>
             </div>`,
      inserted: false
    },
    'denim-shop-3': {
      insertAfter: 16,
      targetTag: '',
      html: `<div class="marketing-tile product-grid" data-marketing-tile="true">
               <a href="/collections/denim-shop" class="marketing-link gap-cl-cta">
                 <div class="img-container">
                   <div class="hover-img-container aspect-ratio-container">
                     <img 
                       class="lazyload aspect-ratio-image" 
                       data-src="https://cdn.shopify.com/s/files/1/0063/4932/4335/files/Banner_3_-_Denim_Page_Update_Desktop.jpg?v=1739163409" 
                       alt="Logo Story"
                     >
                   </div>
                 </div>
               </a>
             </div>`,
      inserted: false
    },
    'feels-like-gap-1': {
      insertAfter: 4,
      targetTag: '',
      html: `<div class="marketing-tile product-grid first-banner" data-marketing-tile="true">
               <a href="/collections/feels-like-gap" class="marketing-link gap-cl-cta">
                 <div class="img-container">
                   <div class="hover-img-container aspect-ratio-container">
                     <img 
                       class="lazyload aspect-ratio-image" 
                       data-src="https://cdn.shopify.com/s/files/1/0063/4932/4335/files/Educ_Banner_Feels_Like_GAP_Desk_1_6afa7da0-34bb-4fa0-8b6b-de4866505558.jpg?v=1743131909" 
                       alt="Logo Story"
                     >
                   </div>
                 </div>
               </a>
             </div>`,
      inserted: false
    },
    'feels-like-gap-2': {
      insertAfter: 14,
      targetTag: '',
      html: `<div class="marketing-tile product-grid" data-marketing-tile="true">
               <a href="/collections/feels-like-gap" class="marketing-link gap-cl-cta">
                 <div class="img-container">
                   <div class="hover-img-container aspect-ratio-container">
                     <img 
                       class="lazyload aspect-ratio-image" 
                       data-src="https://cdn.shopify.com/s/files/1/0063/4932/4335/files/Educ_Banner_Feels_Like_GAP_Desk_2_a491bf5f-9752-453d-9c97-6b35c3388819.jpg?v=1743131908" 
                       alt="Logo Story"
                     >
                   </div>
                 </div>
               </a>
             </div>`,
      inserted: false
    },
    'feels-like-gap-3': {
      insertAfter: 32,
      targetTag: '',
      html: `<div class="marketing-tile product-grid" data-marketing-tile="true">
               <a href="/collections/feels-like-gap" class="marketing-link gap-cl-cta">
                 <div class="img-container">
                   <div class="hover-img-container aspect-ratio-container">
                     <img 
                       class="lazyload aspect-ratio-image" 
                       data-src="https://cdn.shopify.com/s/files/1/0063/4932/4335/files/Educ_Banner_Feels_Like_GAP_Desk_3_6a72aeba-cd2d-41e9-a5d5-b7a2d1b1a45a.jpg?v=1743131909" 
                       alt="Logo Story"
                     >
                   </div>
                 </div>
               </a>
             </div>`,
      inserted: false
    }
  };

  // Add styles if they don't exist
  if (!document.getElementById('marketing-tile-styles')) {
    const marketingStyles = `
      <style id="marketing-tile-styles">
        .marketing-tile.product-grid {
          width: 50% !important;
          flex: 0 0 50% !important;
          max-width: 50% !important;
          margin-bottom: 10px !important;
          display: flex !important;
          align-items: center !important;
          
        }
        
        .marketing-tile .img-container {
          position: relative;
          width: 100%;
          padding-bottom: 81% !important;
          overflow: hidden;
          margin: 0 !important;
          background: #f5f5f5;
        }
        
        .marketing-tile .hover-img-container {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          margin: 0 !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
        }
        
        .marketing-link {
          display: block;
          text-decoration: none;
          color: inherit;
          width: 100%;
        }
        
        .marketing-link:hover {
          opacity: 0.95;
        }
        
        .marketing-tile img {
          width: 100%;
          height: auto !important;
          object-fit: contain !important;
          max-height: 100% !important;
          margin: 0 !important;
        }

        .grid-hide {
          display: none!important;
        }
        .first-banner {
        order: -1;
        }
        @media (max-width: 767px) {
          .marketing-tile.product-grid {
            width: 100% !important;
            flex: 0 0 100% !important;
            max-width: 100% !important;
          }
        }
      </style>
    `;
    jQ('head').append(marketingStyles);
  }
  
  const currentPath = window.location.pathname;
  const currentHandle = currentPath.split('/collections/')[1]?.split('?')[0];
  const divMetaElement = jQ('#div_meta');
  const hasDividers = divMetaElement.length > 0 && divMetaElement.data('switch');

  // Remove any existing marketing tiles first
  jQ('[data-marketing-tile="true"]').remove();

  if (currentHandle) {
    // Check all marketing content entries
    Object.entries(marketingContent).forEach(([key, content]) => {
      // Check if the key contains the current handle (e.g., 'denim-shop' is in 'denim-shop-1')
      if (key.includes(currentHandle) && !content.inserted) {
        if (hasDividers && content.targetTag) {
          // Wait for dividers to be fully rendered
          const checkDividers = setInterval(() => {
            const dividerSection = jQ(`.division--line:contains("${content.targetTag}")`);
            
            if (dividerSection.length) {
              clearInterval(checkDividers);
              
              // Get products only within this divider section
              const nextDivider = dividerSection.nextAll('.division--line').first();
              const sectionEnd = nextDivider.length ? nextDivider : null;
              const productsInSection = dividerSection
                .nextUntil(sectionEnd, '.product-grid:not([data-marketing-tile])')
                .filter((_, el) => !jQ(el).hasClass('marketing-tile'));
              
              console.log(`Found ${productsInSection.length} products in ${content.targetTag} section`);
              
              if (productsInSection.length >= content.insertAfter) {
                jQ(productsInSection[content.insertAfter - 1]).after(content.html);
                content.inserted = true;
                console.log(`Inserted marketing tile ${key} after product ${content.insertAfter} in ${content.targetTag} section`);
              }
            }
          }, 100);

          // Clear interval after 5 seconds to prevent infinite checking
          setTimeout(() => clearInterval(checkDividers), 5000);
        } else {
          // No dividers - insert after specified number of products
          const allProducts = jQ('.product-grid:not([data-marketing-tile])');
          
          if (allProducts.length > content.insertAfter - 1) {
            jQ(allProducts[content.insertAfter - 1]).after(content.html);
            content.inserted = true;
            console.log(`Inserted marketing tile ${key} after product ${content.insertAfter}`);
          }
        }
      }
    });
  }

  // Initialize lazySizes if it exists
  if (typeof window.lazySizes !== 'undefined') {
    lazySizes.init();
  }
}


const originalBuildProductListData = BCSfFilter.prototype.buildProductListData;
BCSfFilter.prototype.buildProductListData = function(data, eventType) {
  originalBuildProductListData.call(this, data, eventType);
  
  // Wait longer for dividers to be rendered
  setTimeout(addMarketingTiles, 500);
};
